import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=318d91bc&scoped=true&"
import script from "./Card.ts?vue&type=script&lang=ts&"
export * from "./Card.ts?vue&type=script&lang=ts&"
import style0 from "./Card.vue?vue&type=style&index=0&id=318d91bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318d91bc",
  null
  
)

export default component.exports